// extracted by mini-css-extract-plugin
module.exports = {"onlyMobile":"Responsive_onlyMobile__WNayc","onlyPC":"Responsive_onlyPC__mpHlT"};